import { Trans, useLingui } from "@lingui/react/macro";
import { AccessibleIcon } from "@offstreetparking/design-system/accessibility";
import { ExternalLinkIcon } from "@offstreetparking/design-system/icons/ExternalLinkIcon";
import { LocationIcon } from "@offstreetparking/design-system/icons/LocationIcon";
import { Tooltip, TooltipContent, TooltipTrigger } from "@offstreetparking/design-system/overlay";
import { Text } from "@offstreetparking/design-system/typography";
import { classNames } from "@offstreetparking/design-system/utils";
import Image from "next/image";
import { ViewMap } from "../../../dataDisplay/ViewMap";
import { useKiosk } from "../../../providers/KioskProvider";
type LocationWithDirectionsProps = {
	location: {
		name: string;
		lot?: {
			centerLat?: string;
			centerLng?: string;
			addressLineOne?: string;
			addressLineTwo?: string;
			city?: string;
			state?: string;
			country?: string;
			postalCode?: string;
			useAddress?: boolean;
			distancesFromPlaces?: {
				timeSeconds?: number;
			};
		};
	};
	localizedDuration: string;
	isDisabled?: boolean;
	isInsideInteractiveElement?: boolean;
};
export const LocationWithDirections = ({
	location,
	localizedDuration,
	isDisabled,
	isInsideInteractiveElement,
}: LocationWithDirectionsProps) => {
	const { isKiosk } = useKiosk();
	const { t } = useLingui();
	return (
		<div className="w-full min-w-0">
			<div className="flex min-w-0 items-center gap-2">
				<AccessibleIcon>
					<LocationIcon className="h-4 w-4 shrink-0" />
				</AccessibleIcon>
				<Tooltip>
					<TooltipTrigger>
						<div className="min-w-0">
							<Text size="md" className={classNames("truncate", isDisabled ? "opacity-50" : "")}>
								{location.name}
							</Text>
						</div>
					</TooltipTrigger>
					<TooltipContent>{location.name}</TooltipContent>
				</Tooltip>
			</div>

			{location.lot && (
				<div className="flex items-center gap-2">
					{!isKiosk && (
						<ViewMap
							place={location.lot}
							tabIndex={isInsideInteractiveElement ? -1 : undefined}
							aria-label={`${t`Open in Maps`} ${t`(opens in a new tab)`}`}
						>
							<Text As="span" size="sm" className="link">
								{t`Open in Maps`}

								<span>
									<ExternalLinkIcon className="ml-0.5 inline h-3 w-3" />
								</span>
							</Text>
						</ViewMap>
					)}

					{location.lot.distancesFromPlaces && (
						<div className="flex items-center gap-1 text-sm">
							<div className="h-1 w-1 rounded-full bg-divider" />

							<Image
								src="https://offstreet.s3.us-west-2.amazonaws.com/icons/walking.svg"
								alt=""
								width={22}
								height={22}
								sizes="22px"
							/>
							<span className="text-sm">
								<Trans>{localizedDuration} to venue</Trans>
							</span>
						</div>
					)}
				</div>
			)}
		</div>
	);
};
